/**
 * Black-Swan i18n
 *
 * @since: 2017-11-23
 * @author: kdydesign.kim
 * @수정이력:
 * - 2018.04.04 ms1124.kim : Vue-validate config merge
 */

import Vue from 'vue'
import VueI18n from 'vue-i18n'

import i18nInstance from './i18n-instance'

Vue.use(VueI18n)

let i18n = void 0

export default ({app, isClient, store}) => {
  const
    locales = store.state.common.locale.locales,
    locale = store.state.common.locale

  app.i18n = i18n = i18nInstance(VueI18n, locale, locales)
}

export {
  i18n
}
